import { Card, Col, DatePicker, Row } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import useGetPlates from "../../functions/Transaction/getPlates";
import useGetTransactions from "../../functions/Transaction/getTransactions";
import TransactionTable from "./TransactionTable";

export default function TransactionCard(props) {
  const {
    transactions,
    setTransactions,
    transactionCardRef,
    setSelectedTransaction,
    setPlates,
    setSelectedPlateIndex,
    setExpandedRowKeys,
  } = props;

  const { RangePicker } = DatePicker;

  const [rangePickerDates, setRangePickerDates] = useState();
  const [selectedDates, setSelectedDates] = useState([
    dayjs().add(-3, "day").format("YYYY-MM-DD"),
    dayjs().format("YYYY-MM-DD"),
  ]);
  const [isRangePickerOpen, setIsRangePickerOpen] = useState();

  const { getTransactions, transactionLoading } = useGetTransactions();
  const { getPlates } = useGetPlates();

  const onRangePickerChange = (dateStrings) => {
    setRangePickerDates(dateStrings);
  };

  const onRangePickerOpenChange = (open) => {
    setIsRangePickerOpen(open);
  };

  const resetPlates = () => {
    setPlates([]);
    setSelectedPlateIndex(0);
    setExpandedRowKeys([]);
  };

  const onViewClicked = (value) => {
    getPlates(resetPlates, value, setPlates);
  };

  useEffect(() => {
    if (!isRangePickerOpen) {
      setSelectedDates(rangePickerDates);
    }
  }, [isRangePickerOpen]);

  useEffect(() => {
    if (selectedDates?.length > 0) {
      getTransactions(selectedDates, setTransactions);
    }
  }, [selectedDates]);

  return (
    <Card
      style={{ height: "100%" }}
      styles={{ body: { height: "calc(100% - 56px)", padding: 10 } }}
      // loading={transactionLoading}
    >
      <div ref={transactionCardRef} style={{ height: "100%" }}>
        {transactionCardRef.current ? (
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <RangePicker
                onChange={onRangePickerChange}
                onOpenChange={onRangePickerOpenChange}
                defaultValue={[dayjs().add(-3, "day"), dayjs()]}
              />
            </Col>
            <Col span={24} style={{ width: "100%" }}>
              <TransactionTable
                transactions={transactions}
                cardRef={transactionCardRef}
                tableHeightOffset={84}
                setSelectedTransaction={setSelectedTransaction}
                onViewClicked={onViewClicked}
              />
            </Col>
          </Row>
        ) : (
          <></>
        )}
      </div>
    </Card>
  );
}
